function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationFerryRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10h2V7h-2v3zm6 0h2V7h-2v3zm-1.412 2.089L27 15.292V11a2 2 0 00-2-2h-1V6a2 2 0 00-2-2h-5V2h-2v2h-5a2 2 0 00-2 2v3H7a2 2 0 00-2 2v4.292l10.412-3.203a1.998 1.998 0 011.176 0zM28.003 27c-.048.239-.64 1.025-1.603 1.025-.962 0-1.555-.786-1.6-.988L22.803 27c-.048.239-.64 1.025-1.603 1.025s-1.555-.786-1.6-.988L17.603 27c-.048.239-.64 1.025-1.603 1.025s-1.555-.786-1.6-.988L12.403 27c-.047.239-.64 1.025-1.603 1.025s-1.555-.786-1.6-.988L7.203 27c-.048.239-.64 1.025-1.603 1.025S4.045 27.239 3.997 27l.003.037H2C2 28.217 3.436 30 5.6 30a3.79 3.79 0 002.6-1.028A3.79 3.79 0 0010.8 30c1.075 0 1.972-.44 2.6-1.028A3.79 3.79 0 0016 30a3.79 3.79 0 002.6-1.028A3.79 3.79 0 0021.2 30a3.79 3.79 0 002.6-1.028A3.79 3.79 0 0026.4 30c2.165 0 3.6-1.783 3.6-2.963L28.003 27z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 25H15V14.308l-10.043 3.09a2 2 0 00-1.31 2.544L5.333 25zM17 25h9.667l1.686-5.058a2 2 0 00-1.31-2.544L17 14.308V25z",
    fill: props.color
  }));
}

export default SvgIconTransportationFerryRexFilled;